// Tags grid items with their id so viselect (which targets elements via a CSS
// selector) can discover them and map a hit back to its id. Attribute, selector
// and readers live here so the raw string is never hand-written elsewhere.
const GRID_ITEM_ID_ATTRIBUTE = 'data-grid-item-id'

export const GRID_ITEM_SELECTOR = `[${GRID_ITEM_ID_ATTRIBUTE}]`

/** Spread onto a grid item's root element to make it selectable. */
export const gridItemMarker = (id: string) => ({
  [GRID_ITEM_ID_ATTRIBUTE]: id
})

/** The item id of `element` or its nearest grid-item ancestor, if any. */
export const getGridItemId = (element: Element | null): string | null =>
  element
    ?.closest<HTMLElement>(GRID_ITEM_SELECTOR)
    ?.getAttribute(GRID_ITEM_ID_ATTRIBUTE) ?? null
